import React from 'react';

import Button from '../../../../components/UI/Button';

import css from '../../../Widgets/SetPlan/SetPlan.module.scss';

interface Props {
  header: string | JSX.Element;
  subheading: string;
  plan: string;
  features: JSX.Element;
  buttonText?: string;
  showInfoIcon?: boolean;
  onInfoClicked: () => void;
  onSelectPlan: () => void;
}

const PlanCard = (props: Props) => {
  return (
    <div className={css.planContainer}>
      <div className={css.plan}>
        {props.showInfoIcon && (
          <img
            src="../../../static/info-icon-green.svg"
            className={css.planOptionInfo}
            onClick={() => props.onInfoClicked()}
            data-testid={`${props.plan}-info`}
          />
        )}
        <h3 className={css.investOptionHeader}>{props.header}</h3>
        <p className={css.investOptionPrice} data-e2e={`${props.plan}-price`}>
          {props.subheading}
        </p>
        <div className={css.checklistRedesign}>{props.features}</div>
        <Button
          text={props.buttonText || 'Select this plan'}
          onClick={props.onSelectPlan}
          data-e2e={`upgrade-${props.plan}`}
        />
      </div>
    </div>
  );
};

export default PlanCard;
